// utils/truncateByDevice.js
export const truncateByDevice = (text, isMobile, isTablet, isDesktop = false) => {
	if (!text) return "";

	let MAX_LENGTH = 40; // desktop default
	if (isMobile) {
		MAX_LENGTH = 20;
	} else if (isTablet) {
		MAX_LENGTH = 30;
	} else if (!isDesktop) {
		MAX_LENGTH = 50;
	}

	return text.length > MAX_LENGTH ? `${text.substring(0, MAX_LENGTH)} ...` : text;
};

export const truncateByDevice2 = (text, isMobile, isTablet, isDesktop = false) => {
	if (!text) return "";

	let MAX_LENGTH = 100; // desktop default
	if (isMobile) {
		MAX_LENGTH = 70;
	} else if (isTablet) {
		MAX_LENGTH = 100;
	} else if (!isDesktop) {
		MAX_LENGTH = 80;
	}

	return text.length > MAX_LENGTH ? `${text.substring(0, MAX_LENGTH)} ...` : text;
};

export const truncateByDeviceTable = (text, isMobile, isTablet, isDesktop = false) => {
	if (!text) return "";

	let MAX_LENGTH = 30; // desktop default
	if (isMobile) {
		MAX_LENGTH = 10;
	} else if (isTablet) {
		MAX_LENGTH = 20;
	} else if (!isDesktop) {
		MAX_LENGTH = 30;
	}

	return text.length > MAX_LENGTH ? `${text.substring(0, MAX_LENGTH)} ...` : text;
};
